import { render } from "./ChangePasswordPage.vue?vue&type=template&id=39de56dd&ts=true"
import script from "./ChangePasswordPage.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordPage.vue?vue&type=script&lang=ts"

import "./ChangePasswordPage.vue?vue&type=style&index=0&id=39de56dd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__